var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcondinas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_5200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 12.6989 23.94 13.3842 23.8252 14.0503C23.7937 14.2327 23.7586 14.4136 23.7188 14.5931L23.017 15.0628C16.2825 19.5684 7.56187 19.8164 0.582188 15.7003C0.582188 15.7003 0.582187 15.7003 0.581719 15.7008C0.510938 15.4823 0.44625 15.2606 0.387656 15.0366C0.303281 14.7131 0.232031 14.3841 0.174844 14.0503C0.106406 13.6556 0.0576563 13.2539 0.0295312 12.8466C0.00984375 12.5672 0 12.2845 0 12C0 9.83344 0.574219 7.80141 1.57875 6.04687C3.64687 2.43422 7.53937 0 12 0C16.4606 0 20.3531 2.43422 22.4212 6.04687C23.0297 7.10953 23.4802 8.27437 23.7408 9.50906C23.903 10.2759 23.9916 11.0691 23.9995 11.8819C24 11.9212 24 11.9606 24 12Z",
    fill: "#92EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 12.8902 23.903 13.7578 23.7188 14.5931L23.017 15.0628C16.2825 19.5684 7.56187 19.8164 0.582188 15.7003C0.510938 15.4819 0.44625 15.2602 0.387656 15.0366C0.135 14.0667 0 13.0491 0 12C0 9.83344 0.574219 7.80141 1.57875 6.04688C3.64687 9.65953 7.53937 12.0938 12 12.0938C16.4606 12.0938 20.3531 9.65953 22.4212 6.04688C23.4258 7.80141 24 9.83344 24 12Z",
    fill: "#63DBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6214 17.5894C22.1362 18.509 21.5357 19.3584 20.8382 20.1169C20.7159 20.25 20.5889 20.3812 20.4576 20.5101C18.8672 22.0729 16.6593 23.2973 14.3732 23.7642C14.2593 23.7876 14.1454 23.8087 14.0315 23.8284C13.3711 23.9414 12.6923 24 12 24H11.9611C11.2818 23.9976 10.6162 23.939 9.9684 23.8284C9.85403 23.8087 9.73965 23.7876 9.62622 23.7651C7.2759 23.294 5.17497 22.1358 3.5395 20.5101C3.39231 20.3639 3.24887 20.2134 3.10918 20.0597C2.43418 19.3153 1.85106 18.4861 1.37903 17.5894H22.6214Z",
    fill: "#6CDC2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6214 17.5894C22.1362 18.509 21.5357 19.3584 20.8382 20.1169C20.7159 20.25 20.5889 20.3812 20.4576 20.5101H3.5395C3.39231 20.3639 3.24887 20.2134 3.10918 20.0597C2.43418 19.3153 1.85106 18.4861 1.37903 17.5894H22.6214Z",
    fill: "#B6E337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3733 23.7642C14.2593 23.7876 14.1454 23.8087 14.0315 23.8284C13.3711 23.9414 12.6923 24 12 24H11.9611C11.2818 23.9976 10.6162 23.939 9.96841 23.8284C9.85403 23.8087 9.73966 23.7876 9.62622 23.7651L10.9012 17.5894H13.0987L14.3733 23.7642Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3733 23.7642C14.2594 23.7876 14.1455 23.8087 14.0316 23.8284C13.3711 23.9414 12.6923 24 12 24V17.5894H13.0988L14.3733 23.7642Z",
    fill: "#6E6F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3553 23.9954C12.2372 23.9984 12.119 24.0001 12 24.0001C11.8809 24.0001 11.7628 23.9984 11.6447 23.9954L11.6948 22.4336H12.3051L12.3553 23.9954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3553 23.9954C12.2372 23.9984 12.1191 24.0001 12 24.0001V22.4336H12.3052L12.3553 23.9954Z",
    fill: "#D0F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.68568V17.5894H8.93335V5.31006L10.4662 6.4974L11.9999 7.68568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.6856V17.5893H10.4662V6.49731L11.9999 7.6856Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2604H15.1144V17.5894H12V11.2604Z",
    fill: "#FFFCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32168 13.9458V17.5894H1.37903C1.06168 16.988 0.794028 16.3566 0.582153 15.7003V15.5152C0.582153 14.6485 1.28481 13.9458 2.15153 13.9458H5.32168Z",
    fill: "#65B2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32163 13.9458V17.5894H2.41772V15.5152C2.41772 14.6485 3.12038 13.9458 3.9871 13.9458H5.32163Z",
    fill: "#159DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86012 9.85645V17.5895H3.74622V11.5064L5.3034 10.6814L6.86012 9.85645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86006 9.85645V17.5895H5.30334V10.6814L6.86006 9.85645Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 12.6375V14.5931C23.6859 14.7422 23.6503 14.8898 23.6119 15.0366C23.3784 15.9323 23.0442 16.7878 22.6214 17.5894H20.3499V9.91125L22.0345 10.6809L22.6383 10.9566C23.2964 11.257 23.7188 11.9138 23.7188 12.6375Z",
    fill: "#65B2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 12.6375V14.5931C23.686 14.7422 23.6503 14.8898 23.6119 15.0365C23.3785 15.9323 23.0442 16.7878 22.6214 17.5893H22.0345V10.6809L22.6383 10.9565C23.2964 11.257 23.7188 11.9137 23.7188 12.6375Z",
    fill: "#159DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3499 8.32739H20.8974V12.646H20.3499V8.32739Z",
    fill: "#6E6F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6235 8.32739H20.8973V12.646H20.6235V8.32739Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 12.6375C23.7188 12.6375 22.9838 12.6417 22.0345 12.6459C21.5091 12.6478 20.918 12.6497 20.3499 12.6511V9.91125L22.0345 10.6809L22.6383 10.9566C23.2964 11.257 23.7188 11.9138 23.7188 12.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2357 6.89478V17.5894H15.1141V9.01638C15.1141 7.84465 16.064 6.89478 17.2357 6.89478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2358 6.89478V17.5894H16.1749V9.01638C16.1749 7.84465 16.6499 6.89478 17.2358 6.89478Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.557 11.2604H15.1141V17.5894H13.557V11.2604Z",
    fill: "#F3E6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86023 13.376H8.93337V17.5894H6.86023V13.376Z",
    fill: "#FFFCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89685 13.376H8.93344V17.5894H7.89685V13.376Z",
    fill: "#F3E6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2357 13.2045H20.3499V17.5894H17.2357V13.2045Z",
    fill: "#FFFCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 13.2045H20.3499V17.5894H18.7928V13.2045Z",
    fill: "#F3E6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5189 10.1986H19.0664V12.9103H18.5189V10.1986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7926 10.1986H19.0664V12.9103H18.7926V10.1986Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.236 12.6165H20.8121V13.2043H17.236V12.6165Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.68568V9.04037H8.93335V5.31006L10.4662 6.4974L11.9999 7.68568Z",
    fill: "#65B2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1536 3.78238C13.1629 3.758 13.1742 3.75097 13.1868 3.76363C13.2 3.77675 13.1883 3.78285 13.1536 3.78238Z",
    fill: "#F3E6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.6856V9.04028H10.4662V6.49731L11.9999 7.6856Z",
    fill: "#159DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78235 16.24H8.93338V17.5894H5.78235V16.24Z",
    fill: "#65B2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0855 16.6018C22.9453 16.9393 22.7902 17.2688 22.6205 17.5895H13.0988C13.0988 17.0443 13.5408 16.6018 14.0864 16.6018H23.0855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 12.6375C23.7188 12.6375 22.9838 12.6417 22.0345 12.6459V10.6809L22.6383 10.9565C23.2964 11.257 23.7188 11.9137 23.7188 12.6375Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86012 9.85645V11.5064H3.74622L5.3034 10.6814L6.86012 9.85645Z",
    fill: "#65B2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86006 9.85645V11.5064H5.30334V10.6814L6.86006 9.85645Z",
    fill: "#159DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7926 12.6165H20.812V13.2043H18.7926V12.6165Z",
    fill: "#6E6F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2006 19.2041H11.7993L11.8513 17.5894H12.1485L12.2006 19.2041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2789 21.6259H11.7211L11.7787 19.8446H12.2212L12.2789 21.6259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2006 19.2041H12V17.5894H12.1486L12.2006 19.2041Z",
    fill: "#D0F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2789 21.6259H12V19.8446H12.2213L12.2789 21.6259Z",
    fill: "#D0F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61742 8.08696C8.61747 8.08265 8.61775 8.07843 8.61775 8.07417C8.61775 7.28981 7.98189 6.65395 7.19753 6.65395C7.0112 6.65395 6.83341 6.69018 6.67037 6.75543C6.35542 6.19125 5.75284 5.80945 5.06078 5.80945C4.16209 5.80945 3.41406 6.45304 3.2515 7.30439C3.20303 7.29745 3.15353 7.29365 3.10314 7.29365C2.61452 7.29365 2.20516 7.6319 2.0957 8.08696H8.61742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23171 8.08694C7.23171 8.08445 7.2319 8.08206 7.2319 8.07958C7.2319 7.62855 6.86627 7.26292 6.41524 7.26292C6.30808 7.26292 6.20585 7.28378 6.1121 7.32128C5.93102 6.99686 5.58447 6.77734 5.18655 6.77734C4.6698 6.77734 4.23968 7.14742 4.14616 7.63698C4.11827 7.633 4.08986 7.6308 4.06085 7.6308C3.77988 7.6308 3.54447 7.82528 3.48157 8.08698H7.23171V8.08694Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2241 3.76447C14.2241 3.76152 14.2244 3.75866 14.2244 3.75575C14.2244 3.22072 13.7906 2.78698 13.2556 2.78698C13.1285 2.78698 13.0072 2.81173 12.896 2.85622C12.6812 2.47137 12.2702 2.21094 11.7981 2.21094C11.185 2.21094 10.6748 2.64997 10.5639 3.23066C10.5309 3.22592 10.4971 3.22334 10.4627 3.22334C10.1294 3.22334 9.85014 3.45406 9.77551 3.76447H14.2241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2789 3.76444C13.2789 3.76275 13.279 3.76111 13.279 3.75942C13.279 3.45178 13.0296 3.20236 12.722 3.20236C12.6489 3.20236 12.5791 3.21656 12.5152 3.24216C12.3917 3.02086 12.1553 2.87109 11.8838 2.87109C11.5313 2.87109 11.238 3.12352 11.1742 3.45745C11.1551 3.45473 11.1357 3.45323 11.116 3.45323C10.9243 3.45323 10.7638 3.58589 10.7208 3.76439L13.2789 3.76444Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2907 5.96046C21.2907 5.95704 21.2909 5.95371 21.2909 5.95029C21.2909 5.32582 20.7847 4.81962 20.1603 4.81962C20.0119 4.81962 19.8704 4.8485 19.7406 4.90043C19.4899 4.45128 19.0101 4.14734 18.4592 4.14734C17.7437 4.14734 17.1482 4.65973 17.0187 5.3375C16.9802 5.33196 16.9407 5.32896 16.9007 5.32896C16.5116 5.32896 16.1857 5.59826 16.0986 5.96051L21.2907 5.96046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 5.96044C20.1875 5.95847 20.1876 5.95655 20.1876 5.95458C20.1876 5.59552 19.8965 5.30442 19.5375 5.30442C19.4521 5.30442 19.3708 5.32102 19.2961 5.35088C19.152 5.0926 18.8761 4.91785 18.5593 4.91785C18.1479 4.91785 17.8055 5.21246 17.731 5.60222C17.7089 5.59903 17.6862 5.5973 17.6631 5.5973C17.4394 5.5973 17.252 5.75213 17.2019 5.96044H20.1875Z",
    fill: "#DFF7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.1797H15.1144V11.7961H12V11.1797Z",
    fill: "#65B2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5571 11.1797H15.1143V11.7961H13.5571V11.1797Z",
    fill: "#159DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5208 12.3429H14.5936V12.9593H12.5208V12.3429Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5571 12.3429H14.5935V12.9593H13.5571V12.3429Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5208 13.4421H14.5936V14.0585H12.5208V13.4421Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5571 13.4421H14.5935V14.0585H13.5571V13.4421Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5208 14.5414H14.5936V15.1578H12.5208V14.5414Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5571 14.5414H14.5935V15.1578H13.5571V14.5414Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 9.93152H10.0825V10.7007H9.31335V9.93152Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 9.93152H10.8517V10.7007H10.0825V9.93152Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 9.93152H11.6209V10.7007H10.8517V9.93152Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 10.7007H10.0825V11.4699H9.31335V10.7007Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 10.7007H10.8517V11.4699H10.0825V10.7007Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 10.7007H11.6209V11.4699H10.8517V10.7007Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 11.4698H10.0825V12.239H9.31335V11.4698Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 11.4698H10.8517V12.239H10.0825V11.4698Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 11.4698H11.6209V12.239H10.8517V11.4698Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 12.239H10.0825V13.0082H9.31335V12.239Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 12.239H10.8517V13.0082H10.0825V12.239Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 12.239H11.6209V13.0082H10.8517V12.239Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 13.0082H10.0825V13.7774H9.31335V13.0082Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 13.0082H10.8517V13.7774H10.0825V13.0082Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 13.0082H11.6209V13.7774H10.8517V13.0082Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 13.7775H10.0825V14.5466H9.31335V13.7775Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 13.7775H10.8517V14.5466H10.0825V13.7775Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 13.7775H11.6209V14.5466H10.8517V13.7775Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 14.5466H10.0825V15.3158H9.31335V14.5466Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 14.5466H10.8517V15.3158H10.0825V14.5466Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 14.5466H11.6209V15.3158H10.8517V14.5466Z",
    fill: "#58586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 15.3158H10.0825V16.085H9.31335V15.3158Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 15.3158H10.8517V16.085H10.0825V15.3158Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 15.3158H11.6209V16.085H10.8517V15.3158Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31335 16.085H10.0825V16.8541H9.31335V16.085Z",
    fill: "#7E7F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0825 16.085H10.8517V16.8541H10.0825V16.085Z",
    fill: "#605F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8517 16.085H11.6209V16.8541H10.8517V16.085Z",
    fill: "#605F74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_5200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondinas);
export default __webpack_public_path__ + "static/media/icondinas.54d40d375791de2740a72ce17708037f.svg";
export { ForwardRef as ReactComponent };